import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/privacy/page.tsx");
